import { FC, ReactNode } from 'react';

import { Button } from '@/components/atoms';

import {
  Dropdown,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../Dropdown/Dropdown';

export type ColumnsOption = {
  value: string;
  label: string;
  isChecked?: boolean;
  icon?: ReactNode;
  onChange: (value: string, isChecked?: boolean) => void;
};

type ColumnsDropdownProps = {
  triggerLabel: string;
  triggerIcon?: ReactNode;
  triggerVariant?: 'default' | 'transparent';
  itemOptions: ColumnsOption[];
  switchOptions: ColumnsOption[];
};

export const ColumnsDropdown: FC<ColumnsDropdownProps> = ({
  triggerLabel,
  triggerIcon,
  triggerVariant = 'transparent',
  itemOptions,
  switchOptions,
}) => {
  return (
    <Dropdown>
      <DropdownMenuTrigger variant={triggerVariant} asChild>
        <Button variant="teritary-bright">
          {triggerIcon} {triggerLabel}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-[250px]">
        {itemOptions.map(({ value, icon, label, isChecked, onChange }) => (
          <DropdownMenuItem
            key={value}
            checked={isChecked}
            onCheckedChange={isChecked => onChange(value, isChecked)}
          >
            {icon && <span className="text-custom-warm-grey-500">{icon}</span>} {label}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <div className="max-h-[300px] overflow-y-auto">
          {switchOptions.map(({ value, label, isChecked, onChange }) => (
            <DropdownMenuRadioItem
              key={value}
              checked={isChecked}
              onCheckedChange={isChecked => onChange(value, isChecked)}
            >
              {label}
            </DropdownMenuRadioItem>
          ))}
        </div>
      </DropdownMenuContent>
    </Dropdown>
  );
};
